import { FC } from 'react';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Box, Button, ButtonAppearance, ButtonSize, ButtonProps, Tab, TabList } from '@bechtel/gds';

export const listWidth = '384px';

export const CrewChangeListContainerStyled = styled.div`
  display: grid;
  grid-template-rows: 56px auto;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grey[1000]};
  left: 0;
  position: absolute;
  top: 0;
  height: 100vh;
  width: ${listWidth};
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
  &::before {
    box-shadow: 14px 0 12px -8px rgba(0, 0, 0, 0.1);
    content: '';
    height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    width: ${({ theme }) => theme.spacings[700]};
  }
`;
export const NewButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.SECONDARY,
  size: ButtonSize.SMALL,
})`
  width: 72px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const NavLinkStyled = styled(NavLink)`
  display: block;
  text-decoration: none;
  transition-timing-function: ease-in-out;
  transition-duration: 80ms;
  transition-property: background-color;
  &:active,
  &.active,
  &:hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }
`;

export const CrewChangeHeaderStyled = styled(Box).attrs({
  px: { sm: '450' },
  py: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  grid-row: 1;
`;
export const CrewChangeListContentStyled = styled.div`
  grid-row: 2;
  height: calc(100vh - 56px);
  overflow: hidden;
  display: grid;
  grid-template-rows: ${({ theme }) => theme.spacings[800]} 76px auto;
`;

//Tab styled
export const TabListStyled = styled(TabList)`
  z-index: 1;
  grid-row: 1;
`;

export const TabStyled = styled(Tab)`
  flex-grow: 1;
  flex-basis: 50%;

  &:focus {
    outline: 0;
  }
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

// Filter dropdown container
export const FilterContainerStyled = styled.div`
  padding-top: ${({ theme }) => theme.spacings[500]};
  padding-bottom: ${({ theme }) => theme.spacings[450]};
  padding-right: ${({ theme }) => theme.spacings[500]};
  padding-left: ${({ theme }) => theme.spacings[500]};
  border-top: 1px solid ${({ theme }) => theme.colors.grey['300']};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['300']};
  width: 100%;
  grid-row: 2;
`;

export const ListStyled = styled(Box).attrs({
  flexGrow: { sm: '1' },
  flexDirection: { sm: 'column' },
})`
  grid-row: 3;
  overflow-y: auto;
`;
